export const components = {
  Modal: () => import("../components/widgets/Modal.vue"),
};
